import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldSlider } from './field-slider';

interface FormFieldSliderProps<T extends FieldValues> extends Omit<
  React.ComponentProps<typeof FieldSlider>,
  'value' | 'onValueChange' | 'errors'
> {
  control: Control<T>;
  name: FieldPath<T>;
}

export function FormFieldSlider<T extends FieldValues>({ control, name, ...rest }: FormFieldSliderProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldSlider
          {...rest}
          value={field.value ?? 0}
          onValueChange={(value) => field.onChange(value)}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
